import React from 'react';

import hoardersImage from '@images_responsive/home/partnerships/hoarders.jpg';

import { BaseCard } from './base_card';
import { SizedResponsiveImage } from './sized_responsive_image';

export const HoardersCard: React.FC = () => (
  <BaseCard
    heading="Hoarders"
    subheading="Clutter works with Hoarders to turn peoples’ lives from chaotic to peaceful"
    container="hoarders"
    media={
      <SizedResponsiveImage
        image={hoardersImage}
        alt="Clutter works with Hoarders to turn people’s lives from chaotic to peaceful"
      />
    }
    body={
      <>
        We’ve all been watching Hoarders for years. Its a classic for home
        renovation TV. This classic just got a brand new makeover by partnering
        with Clutter to help change the lives of Hoarders through out the
        nation.
      </>
    }
  />
);
